import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

const dinner = [
	'Appetizers only',
	'Plated (served)',
	'Buffet',
	'Potluck',
	'Not sure yet',
]

function Dinner({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack(weddingData.reception ? 3 : 6)}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>What style of dinner are you thinking of?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{dinner.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.dinnerStyle ===
												label
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.dinnerStyle ===
												label
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												dinnerStyle: label,
											})
										}
									>
										{label}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.dinnerStyle)
							return toastHelper(
								'Please select a dinner style',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.4} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default Dinner
